import matrix from '../matrix'

import {
 arrMatrix1, arrMatrix2, arrMatrix3, arrPopup1, task1, task2,
} from './arr'

export default {
  components: {
    matrix,
  },
  setup() {
    const arrMatrixFull = [arrMatrix1, arrMatrix2, arrMatrix3]
    const arrMatrixRandom = arrMatrixFull[Math.floor(Math.random() * arrMatrixFull.length)]
    const users = {
      0: 'R&Bbit',
      1: 'Пати Р.',
      2: 'Чиа',
      6: 'Чонгука',
      5: 'Квобби',
    }

    const find = arrMatrixRandom.find(item => item.me)
    const str1 = `Ого, у Семена и Толи похожие музыкальные интересы! Теперь осталось сказать, стоит ли рекомендовать Толе песню ${users[find.author]}${users[find.author] === 'Пати Р.' ? '' : '.'}`
    // const str2 = 'Ого, у Семена и Толи похожие музыкальные интересы!'
    // const strResult = find.author === 0 ? str2 : str1
    const arrPopupChooseUser = [
      { text: str1, buttonTitle: 'Продолжить' },
    ]
    const authorMusic = users[find.author]

    return {
      arrMatrix: arrMatrixRandom,
      arrPopup1,
      task1,
      task2,
      authorMusic,
      arrPopupChooseUser,
    }
  },
}
